import moment from 'moment';

const classNames = require('classnames');

export function transformFieldDefinitionToClasses(fieldName, fieldDefinition) {
  if (fieldDefinition.options && fieldDefinition.options.rawMarkup) {
    // classNames takes an object and returns a class string for each truthy key.
    return classNames(Object.assign(
      {},
      {
        [`field_${fieldName}`]: true,
      },
      ...fieldDefinition.classes.map(i => ({
        // produce a map of {key: true} for each class.
        [i]: true,
      })),
    ));
  }
  // classNames takes an object and returns a class string for each truthy key.
  return classNames(Object.assign(
    {},
    {
      'input-field': true,
      col: true,
      'input-with-icon': true,
      [`field_${fieldName}`]: true,
      field_required: fieldDefinition.required,
    },
    ...fieldDefinition.classes.map(i => ({
      // produce a map of {key: true} for each class.
      [i]: true,
    })),
  ));
}

export function fieldDefinitionsToContractSummaryClasses(fieldDefinitions) {
  const ContractSummaryClasses = {};
  // classes are a mapping from fieldName => ComponentName
  const keys = Object.keys(fieldDefinitions);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    const componentName = fieldDefinitions[key].ComponentName;
    ContractSummaryClasses[key] = componentName;
  }
  return ContractSummaryClasses;
}

export function displayValueForComponentName(componentName, value) {
  switch (componentName) {
    case 'TextInput':
      return value;
    case 'ToggleInput':
      return value ? 'Yes' : 'No';
    case 'DatePickerInput': {
      return value ? moment.unix(value).format('MMMM Do YYYY') : '';
    }
    default:
      return value;
  }
}
// this is a temporary solution.
// I want to change the component architecture with the navbar, to share this data properly.
export const FIELD_NAME_TO_LABEL_TABLE = {
  name: 'Token Name',
  description: 'Description',
  ticker: 'Ticker',
  decimals: 'Decimals',
  initialSupply: 'Initial Supply',
  fixedSupply: 'Fixed Supply',
  timeLocked: 'Time Locked',
  unlockDate: 'Unlock Date',
  transactionFee: 'Transaction Fee',
  transactionFeeAmount: 'Fee Amount',
  priceFloor: 'Enable Price Floor',
  floorPrice: 'Floor Price',
  balance: 'Balance',
};



// WEBPACK FOOTER //
// ./src/utilities/helpers.js